/**
 * Token storage in localStorage. v0.5 is single-user; no refresh flow.
 *
 * 24h server-side TTL slides on each request (see apps/api middleware/auth).
 * Client just hangs onto whatever the login endpoint returned.
 */

const KEY = 'contenthub.token'

export function getToken(): string | null {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem(KEY)
}

export function setToken(token: string): void {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(KEY, token)
}

export function clearToken(): void {
  if (typeof window === 'undefined') return
  window.localStorage.removeItem(KEY)
}

export function hasToken(): boolean {
  return getToken() !== null
}
